import { render, staticRenderFns } from "./AppletShow.vue?vue&type=template&id=cd5c6802&scoped=true"
import script from "./AppletShow.vue?vue&type=script&lang=js"
export * from "./AppletShow.vue?vue&type=script&lang=js"
import style0 from "./AppletShow.vue?vue&type=style&index=0&id=cd5c6802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5c6802",
  null
  
)

export default component.exports